import { useEffect, useRef } from 'react';
import { ADS, adsEnabled } from '@/config/ads';

const WIDTH = 160;
const HEIGHT = 600;

/**
 * 메인 페이지 좌우 여백의 세로 배너 (와이드 스카이스크래퍼 160x600).
 * 본문(max-w-2xl = 42rem) 양옆에 공간이 충분한 1280px 이상 화면에서만 표시합니다.
 * 애드센스에서 "디스플레이 광고 → 고정 크기 160x600" 단위를 만들어 슬롯 ID를 넣으세요.
 */
export function SideAds() {
  if (!adsEnabled()) return null;
  return (
    <>
      <SideAd slot={ADS.slots.sideLeft} side="left" />
      <SideAd slot={ADS.slots.sideRight} side="right" />
    </>
  );
}

function SideAd({ slot, side }: { slot: string; side: 'left' | 'right' }) {
  const pushed = useRef(false);
  useEffect(() => {
    if (!slot || pushed.current) return;
    if (window.innerWidth < 1280) return;
    try {
      (window.adsbygoogle = window.adsbygoogle ?? []).push({});
      pushed.current = true;
    } catch {
      /* 광고 차단기 등 */
    }
  }, [slot]);
  if (!slot) return null;
  // 본문 폭 42rem의 절반(21rem) + 간격 2rem 만큼 중앙에서 떨어뜨립니다.
  const offset = `calc(50% - 21rem - 2rem - ${WIDTH}px)`;
  return (
    <aside className="fixed top-28 z-10 hidden xl:block" style={{ [side]: offset, width: WIDTH, height: HEIGHT }} aria-label="광고">
      <ins className="adsbygoogle" style={{ display: 'inline-block', width: WIDTH, height: HEIGHT }} data-ad-client={ADS.client} data-ad-slot={slot} />
    </aside>
  );
}
